import REF_AFF from '~/shared/cookies/REF_AFF';
import useCookie from '~/shared/hooks/useCookie';

const useRefAff = () => useCookie<string>(REF_AFF);

export default useRefAff;
